<svg *ngIf="ready" width="225" height="220">
	<g>
		<path class="bar" [attr.d]="topRoundedColumn(1)" (click)="redirect(1)"></path>
		<text class="bar-amount" fill="currentColor" x="56" dy="125" text-anchor="middle"
					(click)="redirect(1)">{{getAmount(1)}}</text>
		<text class="bar-total" fill="currentColor" x="56" y="155" text-anchor="middle"
					(click)="redirect(1)">{{getTotal(1)}}</text>
		<text class="bar-type" fill="currentColor" x="56" y="176" text-anchor="middle"
					(click)="redirect(1)">{{getType(1)}}</text>
	</g>
	<g transform="translate(122 , 0 )">
		<path class="bar" [attr.d]="topRoundedColumn(2)" (click)="redirect(2)"></path>
		<text class="bar-amount" fill="currentColor" x="56" dy="125" text-anchor="middle"
					(click)="redirect(2)">{{getAmount(2)}}</text>
		<text class="bar-total" fill="currentColor" x="56" y="155" text-anchor="middle"
					(click)="redirect(2)">{{getTotal(2)}}</text>
		<text class="bar-type" fill="currentColor" x="56" y="176" text-anchor="middle"
					(click)="redirect(2)">{{getType(2)}}</text>
	</g>
</svg>
